function stopSales() {
    let sectionId = document.getElementById("sectionId").value;
    document.getElementById('addToCart-' + sectionId).disabled = true;
    document.getElementById('productPrice-' + sectionId).textContent = "Not available for sale in your country";
}

window.onload = function () { 
    let myCC = sessionStorage.getItem("countryCode");
    if (myCC == 'PR' || myCC == 'GU' || myCC == 'AS' || myCC == 'VI' || myCC == 'MP') {
        myCC = 'US'
	    console.log(myCC);
    }
    let owner = document.getElementById("songOwner").value;
    console.log(owner);
    if  (owner == 'FreeHandMusic.com' || owner == "Novato Music Press") {
	return;
    }
    console.log(myCC);
    let includeCountries = document.getElementById("countryInclude").value;
    console.log(includeCountries);
    let excludeCountries = document.getElementById("countryExclude").value;
    console.log(excludeCountries);
    if (includeCountries != '') {
        let ics = includeCountries.split(',');
	if (!ics.includes(myCC)) {
	    stopSales();
	    console.log(ics);
	    console.log(myCC);
	}
    }
    if (excludeCountries != '') {
        let ecs = excludeCountries.split(',');
	if (ecs.includes(myCC) && excludeCountries != 'CN' && myCC != 'US') {
        stopSales();
	    console.log(ecs);
	    console.log(myCC);
	}
    }
}
